import { render, staticRenderFns } from "./Recap.vue?vue&type=template&id=b6490488&scoped=true&"
import script from "./Recap.vue?vue&type=script&lang=js&"
export * from "./Recap.vue?vue&type=script&lang=js&"
import style0 from "./Recap.vue?vue&type=style&index=0&id=b6490488&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6490488",
  null
  
)

export default component.exports